import React from "react";
import Slides from "./Homepage/Data/CarouselData.json";
import HomeSec1 from "./Homepage/HomeSec1";
import HomeSec2 from "./Homepage/HomeSec2";
import Ourrooms from "./About/Ourrooms";
import HomeSec4 from "./Homepage/HomeSec4";
import HomeSec5 from "./Homepage/HomeSec5";
import HomeSec7 from "./Homepage/HomeSec7";
import Carousel from "./Homepage/Carousel";
import HeroSec from "./Homepage/HeroSec";
import HomeSS from "./Homepage/HomeSS";
import HomeSec6 from "./Homepage/HomeSec6";

const Home = () => {
  return (
    <div>
      <HeroSec />
      <HomeSec1 />
      <HomeSec6 />
      <HomeSS />
      <HomeSec2 />
      <Ourrooms />
      <HomeSec4 />
      <HomeSec5 />
      <Carousel data={Slides} />
      <HomeSec7 />
    </div>
  );
};

export default Home;
